module.exports = __webpack_public_path__ + "static/media/LogoWithText.ec5b33d5.svg";